import React from 'react';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { format  } from 'date-fns';
import localeMap from '../crud/locales';

export default function GridDateEditCell(props) {
  const { id, field, value, colDef ,locale} = props;
  const apiRef = useGridApiContext();

  // Επιλογή Picker ανάλογα με τον τύπο της στήλης
  const PickerComponent = colDef.type === 'dateTime' ? DateTimePicker : DatePicker;

  // Όταν αλλάζει η τιμή στο picker
  const handleChange = (newValue) => {
    let chenDate = format(newValue, "yyyy-MM-dd'T'HH:mm")
    apiRef.current.setEditCellValue({ id, field, value: chenDate ?? null });
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={localeMap[locale] ||  localeMap['el']}
    >
      <PickerComponent
        value={value ?? null}
        onChange={handleChange}
        ampm={false}
        slotProps={{ textField: { size: 'small', fullWidth: true } }}
      />
    </LocalizationProvider>
  );
}
